function syncContentWidths(firstContent, secondContent) {
  if (!firstContent || !secondContent) {
    return;
  }
  const firstWidth = firstContent.offsetWidth;
  secondContent.style.width = firstWidth + 'px';
}

document.addEventListener('DOMContentLoaded', function() {
  const announcementDividers = document.querySelectorAll('.boa-announcement-divider');
  
  announcementDividers.forEach(function(divider) {
    const scrollContainer = divider.querySelector('.boa-announcement-divider__scroll');
    const contentBlocks = divider.querySelectorAll('.boa-announcement-divider__content');
    
    if (!scrollContainer || contentBlocks.length < 2) {
      return;
    }
    
    const firstContent = contentBlocks[0];
    const secondContent = contentBlocks[1];
    
    if (!firstContent || !secondContent) {
      return;
    }
    
    syncContentWidths(firstContent, secondContent);
    
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        syncContentWidths(firstContent, secondContent);
      }, 250);
    });
  });
});
